export interface OrgOption {
    id: string;
    name: string;
    parentOrganizationId?: string | null;
}

/**
 * Flattens a flat org list into { org, depth } rows, nested under their parent and
 * alphabetized at every level. An org whose parent isn't in this list (out of the
 * caller's scope) renders as top-level rather than vanishing.
 */
export const flattenOrgOptions = (orgs: OrgOption[]): { org: OrgOption; depth: number }[] => {
    const ids = new Set(orgs.map((o) => o.id));
    const byParent = new Map<string | null, OrgOption[]>();
    for (const org of orgs) {
        const parentKey =
            org.parentOrganizationId && ids.has(org.parentOrganizationId) ? org.parentOrganizationId : null;
        byParent.set(parentKey, [
            ...(byParent.get(parentKey) ?? []),
            org,
        ]);
    }
    const flatten = (parentKey: string | null, depth: number): { org: OrgOption; depth: number }[] =>
        [...(byParent.get(parentKey) ?? [])]
            .sort((a, b) => a.name.localeCompare(b.name))
            .flatMap((org) => [
                { org, depth },
                ...flatten(org.id, depth + 1),
            ]);
    return flatten(null, 0);
};
